import { FormControl, MenuItem, Select } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

const initialState = {
    data: [],
    filtered: [],
    country: '',
}
const countries = [];

const TableGrid = (props) => {

    const [state, setState] = useState(initialState);
    // const [data, setData] = useState([]);
    // const [filtered, setFiltered] = useState([]);
    // const [country, setCountry] = useState('');

    const handleSelectChange = (event) => {
        setState((prevState) => {
            const country = event.target.value
            const filtered = prevState.data.filter(d => d['Country of origin'] === country);
            return {
                data: prevState.data,
                filtered,
                country
            }
        });
    }

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                // setData(results.data.map((d, idx) => { d.id = idx }));
                setState((prevState) => {
                    const data = results.data;
                    data.map((d, idx) => {
                        d.id = idx
                    });
                    data.forEach(d => {
                        if (countries.indexOf(d['Country of origin']) < 0) {
                            countries.push(d['Country of origin']);
                        }
                    });
                    const country = countries[0];
                    const filtered = data.filter(d => d['Country of origin'] === country);
                    return {
                        data,
                        filtered,
                        country
                    }
                });
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const cols = [
        { field: 'Report name ID', headerName: 'Pesticide', flex: 1, minWidth: 100 },
        { field: 'EU status', headerName: 'EU status', flex: 1, minWidth: 100 },
        { field: 'Food commodity', headerName: 'Food commodity', flex: 1, minWidth: 100 },
        { field: 'Quantified results', type: 'number', headerName: 'Quantified results', flex: 1, minWidth: 100 },
        { field: 'Between LOQ and LL results', type: 'number', headerName: 'Between LOQ and LL results', flex: 1, minWidth: 100 },
        { field: 'Above LL results', type: 'number', headerName: 'Above MRL', flex: 1, minWidth: 100 },
        { field: 'Non-compliant results', type: 'number', headerName: 'Non-compliant', flex: 1, minWidth: 100 },
    ]

    return (
        <Box sx={{ height: 400 }}>
            <Box display='flex' justifyContent='space-between' alignItems='flex-end'>
                <Box>
                    <p>Summary of the findings by country of origin</p>
                </Box>
                <Box>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <Select value={state.country} onChange={handleSelectChange}>
                            {
                                countries.map((c, idx) => {
                                    return <MenuItem key={idx} value={c}>{c}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl>

                </Box>
            </Box>
            <DataGrid
                components={{
                    Toolbar: GridToolbar,
                }}
                columns={cols}
                rows={state.filtered}
            />
        </Box>
    );
}

export default TableGrid;